import { CustomTable } from "./CustomTable";
import { useEffect, useState } from "react";
import {  fetchCVApplicationEndPoint} from "../../../configuration";
import { getRandomUUID } from "../../../Token";
import { useNavigate } from "react-router-dom";
import { Box } from "@mui/system";
import { styles } from "../../utility/styleUtils";
import { Icon } from "@vds/icons";
import { TextLink } from "@vds/buttons";
import { Link, useLocation } from "react-router-dom";
import { isItGateway } from "../../utility/Utils";
import {
  createSorterForAlertStatus,
  createTableFilterList,
  createTableFilterStaticList,
} from "../../utility/Utils";
import GmtToLocal from "../../utility/GmtToLocal";
import { useDispatch, useSelector } from "react-redux";
import {getCommonAppTableColumns} from "../../../model/cvappsTableColumns"

const CVAppsTable = (props) => {
  const { state } = useLocation();
  const stateData = state?.data;
  const {
    appList,
    tableTitle,
    pageName,
    setRefreshCVApp,
    setFetchCVApp,
    fetchCVApp,
    // handleDelete,
    setShowDeleteCVApp,
    handleRefresh,
    searchInputText,
    tableLoading,
    setSelectedCVApp,
    buttonAction,
    setSelectedCheckBox,
    onButtonClick,
    // fetchCVApps,
    setResourceId,

  } = props;
  const dispatch = useDispatch();
  const [cameraDevices, setCameraDevices] = useState([]);
  const [selectedAlert, setSelectedAlert] = useState(null);
  const [hasToBeRead, setHasToBeRead] = useState(false);
  const [hasToBeClosed, setHasToBeClosed] = useState(false);
  const [filteredInfo, setFilteredInfo] = useState([]);
  const [showTableFilter, setShowTableFilter] = useState(false);
  const [fetchCVApps, setFetchCVApps] = useState(false);
  const navigate = useNavigate();

  const columnMetaDataInfo = {
    showTableFilter,
    filteredInfo,
    appList,
    createSorterForAlertStatus,
    createTableFilterList,
    createTableFilterStaticList,
    GmtToLocal,
  };
  const columnDetails = getCommonAppTableColumns(columnMetaDataInfo);
  useEffect(() => {
    console.log("State has been updated:", fetchCVApps);

    if (fetchCVApps) {
      console.log("Using updated state:", fetchCVApps);
    }
  }, [fetchCVApps]);
  const handleTableChange = (pagination, filters, sorter) => {
    console.log("Various parameters", pagination, filters, sorter);
    setFilteredInfo(filters);
  };
 
  const handleFilterAction = () => {
    setShowTableFilter(!showTableFilter);
    if (showTableFilter) {
      setFilteredInfo([]);
    }
  };
  const handleDelete=(record)=>{
    setSelectedCVApp(true);
    if(record){
      setShowDeleteCVApp(true);
      setResourceId(record.id);
    }

}

  useEffect(() => {
    // setSelectedAlert(null);
    // setHasToBeClosed(false);
    // setHasToBeRead(false);
  }, [fetchCVApp]);

  const renderedColumns = columnDetails.map((item, index) => {
    const {
      title,
      showCheckBox,
      customStyle,
      isLink,
      editColumn,
      showMultiColorStatus,
      showMultiColorSeverity,
      navLinks,
      hasInfoLink,
      isDelete,
    } = item;
    return {
      ...item,
      title: () => {
        return (
          <div className="sasp_font-size-14 sas_font-weight-bold">{title}</div>
        );
      },
      render: (text, record) => {
        let linkUrl = isLink ? navLinks.url : "";
        const state = {
          data: record?.device,
          title: `More info for ${record?.device?.name}`,
          fields: record?.device?.fields || {},
        };

        if (hasInfoLink) {
          linkUrl = isItGateway(record.device)
            ? navLinks.gatewayInfo
            : navLinks.sensorInfo;
        }

        const fontWeight =
          showMultiColorSeverity || showMultiColorStatus
            ? "sasp_font-weight-bold"
            : "sasp_font-weight-400";
        const textValue = showMultiColorSeverity
          ? `${text?.charAt(0).toUpperCase()}${text?.slice(1).toLowerCase()}`
          : showMultiColorStatus
          ? record.iscleared
            ? "Closed"
            : record.isacknowledged
            ? "Read"
            : "New"
          : text;
        let textColor =
          showMultiColorSeverity || showMultiColorStatus
            ? `sasp_${textValue.toLowerCase()}-text-color`
            : "";

        return {
          children: (
            <div style={{ display: "flex" }}>
             
              {isLink && (
                <TextLink
                  type="standAlone"
                  onClick={() => navigate(linkUrl, { state })}
                  size="large"
                  style={{
                    ...styles.textBoldUnderline,
                    marginLeft: showCheckBox ? 10 : "",
                  }}
                >
                  {textValue}
                </TextLink>
              )}

              {!isLink && (
                <h5
                  style={{ ...customStyle }}
                  className={`sasp_font-size-14 ${fontWeight} ${textColor}`}
                >
                  {textValue}
                </h5>
              )}
                {editColumn && !record.systemRule ? (
                <div style={{ display: "flex", gap: "10px", ...customStyle }}>
        
                  <div onClick={() => {
                    handleDelete(record);
                    // setReloadCVApp();
                    // setRefreshCVApp();
                  }}>
                    <Icon name="trash" size="medium" color="#000000" />
                  </div>
                </div>
              ) : null}



            </div>
          ),
        };
      },
    };
  });
  return (
    <>
      <Box
        sx={{
          p: 2,
          border: "1px solid",
          borderTopLeftRadius: 3,
          borderTopRightRadius: 3,
        }}
      >
        <div className="sasp_d-flex sasp_justify-content-between">
          <div style={styles.hHeader}>{tableTitle}</div>

          <div
            className="sasp_d-flex sasp_justify-content-between sasp_align-items-center"
            style={{ gap: "10px" }}
          >
            {(!pageName || pageName !== "dashboard") && (
              <>
                <div onClick={(e) => {
                  setRefreshCVApp(false);
                  }}>
                  <Icon name="sync" size="large" color="#000000" />
                </div>
                <div onClick={(e) => handleFilterAction()}>
                  <Icon
                    name="filter"
                    size="large"
                    color={showTableFilter ? "#EE0000" : "#000000"}
                  />
                </div>
              </>
            )}
          </div>
        </div>
      </Box>

      <Box
        sx={{
          border: "1px solid",
          borderBottomLeftRadius: 2,
          borderBottomRightRadius: 2,
          borderTopWidth: 0,
        }}
      >
        <CustomTable
          {...props}
          columnDetails={columnDetails}
          dataList={appList}
          searchColumns={[
            "name",
            "version",
            "status",
            "type",
            "image",
          ]}
          handleChange={handleTableChange}
          // tableLoading={tableLoading}
          // searchInputText={searchInputText}
          // setRefreshCVApp={setRefreshCVApp}
          handleDelete={handleDelete}
          handleRefresh={handleRefresh}
          showTableFilter={showTableFilter}
          renderedColumns={renderedColumns}
          filteredInfo={filteredInfo}
          tableName="cvapps"
        />
      </Box>
    </>
  );
};

export default CVAppsTable;
